import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { StyledContainer, StyledHero, StyledWrapper } from './HPCHero.styled';

const HPCHero: React.FC = () => {
  const { t } = useI18n('hiring-process-comparison');

  return (
    <StyledHero>
      <StyledWrapper>
        <StyledContainer>
          <Heading1 editorial alignLeft>
            {t('hiring-process-comparison.hero.title')}
          </Heading1>
          <p>{t('hiring-process-comparison.hero.desc')}</p>
          <ButtonLink href="#comparator" variant="brandTalent">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>{t('hiring-process-comparison.hero.cta')}</span>
          </ButtonLink>
        </StyledContainer>
      </StyledWrapper>
    </StyledHero>
  );
};

export default HPCHero;
